import * as React from "react";
import { FilterSelect, type FilterSelectProps } from "@/components/ui/filter-select";
import { LabeledFilterField } from "@/components/ui/labeled-filter-field";

const DEFAULT_PERIOD_OPTIONS = (
  <>
    <option value="hoje">Hoje</option>
    <option value="ontem">Ontem</option>
    <option value="7">Últimos 7 dias</option>
    <option value="30">Últimos 30 dias</option>
    <option value="personalizado">Personalizado</option>
  </>
);

export type PeriodFilterSelectProps = Omit<FilterSelectProps, "aria-label" | "children"> & {
  label?: string;
  /** Fundo do recorte do label (igual ao fundo da página). */
  labelBgClass?: string;
  children?: React.ReactNode;
};

export function PeriodFilterSelect({
  label = "Período",
  labelBgClass = "period-filter-label-bg",
  className = "",
  id,
  children = DEFAULT_PERIOD_OPTIONS,
  ...props
}: PeriodFilterSelectProps) {
  return (
    <LabeledFilterField label={label} htmlFor={id} labelBgClass={labelBgClass}>
      <FilterSelect id={id} aria-label={label} className={className} {...props}>
        {children}
      </FilterSelect>
    </LabeledFilterField>
  );
}
